export const MEDIDAS_ADOTADAS_COBRANCA = 'MEDIDAS_ADOTADAS_COBRANCA';
export const MEDIDAS_ADOTADAS_COBRANCA_START =
  'MEDIDAS_ADOTADAS_COBRANCA_START';
export const MEDIDAS_ADOTADAS_COBRANCA_SUCCESS =
  'MEDIDAS_ADOTADAS_COBRANCA_SUCCESS';
export const MEDIDAS_ADOTADAS_COBRANCA_ERROR =
  'MEDIDAS_ADOTADAS_COBRANCA_ERROR';
